import { PropsWithChildren, ReactElement } from 'react';

import TextField, { TextFieldProps } from '@mui/material/TextField';

import { BaseRenderInputProps } from './models/base-render-input.props';

const BaseRenderInput = <TValuesModel,>(
  props: PropsWithChildren<BaseRenderInputProps<TValuesModel>>
): ReactElement => {
  const {
    children,
    errors,
    id,
    label,
    name,
    required,
    touched,
    ...textFieldProps
  } = props;

  return (
    <TextField
      {...(textFieldProps as TextFieldProps)}
      error={touched[name] && !!errors[name]}
      helperText={!!errors[name] && touched[name] && errors[name]}
      key={id}
      label={label}
      variant="filled"
      {...(required && {
        InputLabelProps: {
          required,
          'data-testid': 'required-label',
        },
      })}
    >
      {children}
    </TextField>
  );
};

export default BaseRenderInput;
